// extracted by mini-css-extract-plugin
module.exports = {"cards":"HowItWorksWrapper_cards__1ymTL","space":"HowItWorksWrapper_space__3dPYa"};